export default {
  main: {
    site_id: 702,
    title: "Terminal PRO",
    showBetBuilderSection: true,
    staffPassword: "124578",
    terminalId: 35229,
    enableTicketTimer: true,
    hasDayFilter: true,
    enableHeaderAdminSection: true,
    homeMediaSlides: [
      {
        type: "multiple",
        path: "betting/prematch/all/multiples",
      },
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    websitePasswordHash: "755c4fc9d818cb89805127f341e41440b7fe11535e047e2ecb35652707b03838",
    logoSize: "big",
    availableLanguages: {
      "@replace": true,
      eng: {
        short: "EN",
        name: "ENG",
        region: "UnitedKingdom",
        order: 1,
      },
      chi: {
        short: "CH",
        name: "CHI",
        order: 9,
      },
    },
  },
  splitScreen: false,
  verticalHome: {
    grid: [["shortpages"], ["slider"], ['comp'], ["populargames"]],
    gridColumns: "1fr",
    // gridRows: "1.5fr 7fr 6fr 4fr",
    gridRows: "1.17fr 3fr 1.6fr 8.4fr",
  },
  home: {
    liveGamesCount: 10,
  },
  routes: [
    {
      url: 'betting/live/all',
      name: 'Live',
      type: 'live',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/live/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/live/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      url: 'betting/prematch/all',
      type: 'prematch',
      name: 'Upcoming',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      url: 'betting/results',
      name: 'Results',
      enabled: true,
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  defaultTerminalParams: { pid: 702, tid: 35229, token: "0BaWGQ==", currency: "TZS" },
  betslip: {
    taxPercentOnStake: 10
  },
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
    {
      name: "Lottery tickets",
      type: "lotteryTicket",
      hideOnRestrictMode: true,
    },
    {
      name: "Cash-out",
      type: "cashoutTicket",
      hideOnRestrictMode: true,
    }
  ],
};
